var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSettings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.69233 19.5L7.31156 16.4538C7.04361 16.3641 6.76892 16.2384 6.48751 16.0769C6.20609 15.9153 5.95448 15.7422 5.73268 15.5576L2.91153 16.7499L0.603882 12.75L3.04426 10.9058C3.02117 10.757 3.00482 10.6077 2.99521 10.4577C2.98559 10.3077 2.98078 10.1583 2.98078 10.0096C2.98078 9.86728 2.98559 9.72273 2.99521 9.57593C3.00482 9.42913 3.02117 9.26855 3.04426 9.0942L0.603882 7.24998L2.91153 3.26925L5.72306 4.45195C5.96409 4.26092 6.22147 4.08623 6.49518 3.9279C6.76892 3.76955 7.03783 3.6423 7.30193 3.54615L7.69233 0.5H12.3076L12.6884 3.55578C12.9884 3.66474 13.2599 3.79198 13.5029 3.9375C13.7458 4.08302 13.991 4.2545 14.2384 4.45195L17.0884 3.26925L19.3961 7.24998L16.9173 9.12303C16.9532 9.28458 16.9727 9.43554 16.9759 9.57593C16.9791 9.71631 16.9807 9.85766 16.9807 9.99998V10.375C16.9807 10.4968 16.9705 10.6218 16.95 10.75H12.9096C12.9467 10.6218 12.973 10.4993 12.9884 10.3827C13.0038 10.266 13.0115 10.1384 13.0115 9.99998C13.0115 9.16794 12.7195 8.45993 12.1355 7.87595C11.5516 7.29198 10.8436 7 10.0115 7C9.16922 7 8.45866 7.29198 7.87981 7.87595C7.30097 8.45993 7.01156 9.16794 7.01156 9.99998C7.01156 10.6589 7.19585 11.242 7.56443 11.749C7.93301 12.256 8.41153 12.6166 8.99998 12.8307V19.5H7.69233ZM15.8077 18.4807V12.9423L20.423 15.7115L15.8077 18.4807ZM11.1923 18.4807V12.9423L15.8077 15.7115L11.1923 18.4807Z",
    fill: "#1C1B1F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.54135b24.svg";
export { ForwardRef as ReactComponent };